// src/Notes/NotesContent/Probability/kl-divergence.js

const timeSeries = String.raw`
### Definition
Weakly stationary (or covariance stationary) time series have constant mean, variance, and autocovariance over time.
A time series \(\{X_t\}\) is weakly stationary if:

1. **Constant Mean**: \(E[X_t] = \mu\) for all \(t\)
2. **Constant Variance**: \(Var(X_t) = \sigma^2\) for all \(t\)
3. **Autocovariance depends only on lag**: \(Cov(X_t, X_{t+h}) = \gamma(h)\) for all \(t\) and lag \(h\)

### Examples;
`;
export default timeSeries;